import { type IFramework } from '@/framework';
import { type TextSelectionRange } from '@/utils/text-kit';
import { type ILayerProps, type ITexture, type Optional } from '@/version-types';
import { FillColor } from './fill-color';
import { FillGradient } from './fill-gradient';
import { FillTexture } from './fill-texture';
import { type IShapeText } from './shape-text';

export interface IFill {
    setFillColor(
        layerID: string,
        color: string,
        options?: { range?: Optional<TextSelectionRange>; writeHistory?: boolean },
    ): Promise<{ layer: ILayerProps; range: TextSelectionRange | null } | void>;

    setFillGradient(layerID: string, gradient: string, options?: { writeHistory?: boolean }): ILayerProps | void;

    setFillTexture(layerID: string, texture: ITexture): ILayerProps | void;
}

export class Fill implements IFill {
    private fillColor: FillColor;
    private fillGradient: FillGradient;
    private fillTexture: FillTexture;

    constructor(framework: IFramework, shapeText: IShapeText) {
        this.fillColor = new FillColor(framework, shapeText);
        this.fillGradient = new FillGradient(framework);
        this.fillTexture = new FillTexture(framework);
    }

    setFillColor(
        layerID: string,
        color: string,
        options?: { range?: Optional<TextSelectionRange>; writeHistory?: boolean },
    ) {
        return this.fillColor.setFillColor(layerID, color, options);
    }

    setFillGradient(layerID: string, gradient: string, options?: { writeHistory?: boolean }) {
        return this.fillGradient.setFillGradient(layerID, gradient, options);
    }

    setFillTexture(layerID: string, texture: ITexture) {
        return this.fillTexture.setFillTexture(layerID, texture);
    }
}
